import PropTypes from 'prop-types';

export const FlightClass = Object.freeze({
    TOURIST: 'TOURIST',
    PREMIUM_ECONOMY: 'PREMIUM_ECONOMY',
    BUSINESS: 'BUSINESS',
    FIRST: 'FIRST',
});

export const FlightClassCMS = {
    [FlightClass.TOURIST]: 'moreOptions.switchertitle.economy',
    [FlightClass.PREMIUM_ECONOMY]: 'moreOptions.switchertitle.premium',
    [FlightClass.BUSINESS]: 'moreOptions.switchertitle.business',
    [FlightClass.FIRST]: 'moreOptions.switchertitle.first',
};

export const FlightClassProp = PropTypes.oneOf(Object.values(FlightClass));
export const FlightClassPropDefault = FlightClass.TOURIST;
